export default function (store) {
    return {
        user: store.auth.user,
        clientID: store.appClient.clientID
    }
}